import { Directive, Input, forwardRef, OnInit } from '@angular/core';
import { NG_VALIDATORS, Validator, FormControl, ValidatorFn, AbstractControl } from '@angular/forms';

import { equalToValidator } from './validator';

const VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => EqualToDirective),
  multi: true
};

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[equalTo][formControlName],[equalTo][formControl],[equalTo][ngModel]',
  providers: [ VALIDATOR ]
})
export class EqualToDirective implements Validator, OnInit {
  @Input() equalTo: FormControl;

  private validator: ValidatorFn;

  ngOnInit() {
    this.validator = equalToValidator(this.equalTo);
  }

  validate(c: AbstractControl): {[key: string]: any} {
    return this.validator(c);
  }
}
